"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![RowIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNS4zMiAxMi43NSIgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+Um93czwvdGl0bGU+CiAgPGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+CiAgICA8ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPgogICAgICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNC41NywxLjVILjc1QS43Ni43NiwwLDAsMSwwLC43NS43Ni43NiwwLDAsMSwuNzUsMEgxNC41N2EuNzUuNzUsMCwwLDEsMCwxLjVaIi8+CiAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE0LjU3LDcuMTNILjc1YS43NS43NSwwLDAsMSwwLTEuNUgxNC41N2EuNzUuNzUsMCwwLDEsMCwxLjVaIi8+CiAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE0LjU3LDEyLjc1SC43NWEuNzUuNzUsMCwwLDEsMC0xLjVIMTQuNTdhLjc1Ljc1LDAsMCwxLDAsMS41WiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==)
 */
exports.RowIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 15.32 12.75", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M14.57 1.5H.75A.76.76 0 0 1 0 .75.76.76 0 0 1 .75 0h13.82a.75.75 0 0 1 0 1.5zm0 5.63H.75a.75.75 0 0 1 0-1.5h13.82a.75.75 0 0 1 0 1.5zm0 5.62H.75a.75.75 0 0 1 0-1.5h13.82a.75.75 0 0 1 0 1.5z" })));
};
//# sourceMappingURL=Icon.Row.js.map